module.exports = __webpack_public_path__ + "static/img/logo.54ab8a2a.png";